import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=10849d74&scoped=true&"
import script from "./intro.vue?vue&type=script&lang=js&"
export * from "./intro.vue?vue&type=script&lang=js&"
import style0 from "./intro.vue?vue&type=style&index=0&id=10849d74&prod&lang=css&"
import style1 from "./intro.vue?vue&type=style&index=1&id=10849d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10849d74",
  null
  
)

export default component.exports